module.exports = __webpack_public_path__ + "static/gh-1-3a81f17b73ac4be7be08a83c60360606.jpg";